import script from "./icon-plus.vue?vue&type=script&lang=ts&setup=true"
export * from "./icon-plus.vue?vue&type=script&lang=ts&setup=true"

import "./icon-plus.vue?vue&type=style&index=0&id=3e055746&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e055746"]])

export default __exports__